import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/admin_user_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('AdminUser', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('AdminUser', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
